var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 209,
    height: 209,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 5,
    stroke: "#98f673",
    fill: "none",
    r: 0,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "spline",
    keySplines: "0 0.2 0.8 1",
    keyTimes: "0;1",
    values: "0;31",
    dur: "1.9607843137254901s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    keyTimes: "0;1",
    values: "1;0",
    dur: "1.9607843137254901s",
    repeatCount: "indefinite",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 5,
    stroke: "#f673ce",
    fill: "none",
    r: 0,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.9803921568627451s",
    calcMode: "spline",
    keySplines: "0 0.2 0.8 1",
    keyTimes: "0;1",
    values: "0;31",
    dur: "1.9607843137254901s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.9803921568627451s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    keyTimes: "0;1",
    values: "1;0",
    dur: "1.9607843137254901s",
    repeatCount: "indefinite",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingRadar);
export default __webpack_public_path__ + "static/media/loading-radar.ff475a352e5591f27bdf91c97023e5a6.svg";
export { ForwardRef as ReactComponent };